export default __webpack_public_path__ + "static/media/home_keep_fighting.bc2fa92b.mp3";